import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import check from "../../assets/check_ico.svg";
import calendarIco from "../../assets/calendar_ico.svg";
import rightArrow from "../../assets/rightArrow.svg";
import "./periodic.css";
import close from "../../assets/close.svg";
 import BasicDateTimePicker from "../DateTimePicker";
import dayjs from "dayjs";
import Dropdown from "../DropDown/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { forceUpdate, reset } from "../../redux/slices/scheduleSlice";
 import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const Periodic = ({ handleSubmit, type, handleClose }) => {
  const [step, setStep] = useState(0);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const authData = useSelector((state) => state.auth.data);
  const isSuccess = useSelector((state) => state.schedule.isSuccess);
  const isError = useSelector((state) => state.schedule.isUpdateError);
  const [selectFromTime, setSelectedFromTime] = useState("");
  const [selectToTime, setSelectedToTime] = useState("");

  const [difference, setDifference] = useState(0);
  const dispatch = useDispatch();
  const [selectScheduled, setSelectScheduled] = useState({
    label: "Custom",
    value: "custom",
  });
  const [selectDay, setSelectDay] = useState({
    label: "",
    value: "",
  });

  const handleChange = (event) => {
    setSelectScheduled(event);
    setSelectedFromDate(null);
    setSelectedToDate(null);
    if (event !== "weekly") {
      setSelectDay({
        label: "",
        value: "",
      });
    }
  };
  const handleDayChange = (event) => {
    setSelectDay(event);
  };
  useEffect(() => {
    if (isSuccess === true) {
      setLoader(false);
      setStep(1);
      setTimeout(() => {
        dispatch(reset());
      }, 500);
    }
    if (isError === true) {
      setLoader(false);
      setStep(2);
      setTimeout(() => {
        dispatch(reset());
      }, 500);
    }
  }, [isSuccess, isError, dispatch]);

  // useEffect(() => {
  //   let currentError = "";

  //   // Check if selectedFromDate is in the past
  //   if (selectedFromDate && dayjs(selectedFromDate).isBefore(dayjs())) {
  //     currentError = "Start date cannot be in the past";
  //   }

  //   // Check if selectedToDate is in the past
  //   if (selectedToDate && dayjs(selectedToDate).isBefore(dayjs())) {
  //     currentError = currentError ? "Start and end dates cannot be in the past" : "End date cannot be in the past";
  //   }

  //   // Check if both dates are selected and valid
  //   if (selectedFromDate && selectedToDate && !currentError) {
  //     const difference = dayjs(selectedToDate).diff(dayjs(selectedFromDate), "hour");
  //     console.log("difference>>>>>", difference);

  //     // Check if the difference is less than 1 hour
  //     if (difference < 1) {
  //       currentError = "Date difference must be at least 1 hour";
  //     } 
  //       setDifference(difference); // Only set difference if valid
  //   }

  //   // Set error state if any validation failed
  //   setError(currentError);
  // }, [selectedFromDate, selectedToDate]);


  useEffect(() => {
    let currentError = "";
    let difference = 0;

    const now = dayjs();

    // Check if selectedFromDate is in the past
    if (selectedFromDate && dayjs(selectedFromDate).isBefore(now)) {
      currentError = "Start date cannot be in the past";
    }

    // Check if selectedToDate is in the past
    if (selectedToDate && dayjs(selectedToDate).isBefore(now)) {
      currentError = currentError
        ? "Start and end dates cannot be in the past"
        : "End date cannot be in the past";
    }

    // Check if both dates are selected and valid
    if (!currentError && selectedFromDate && selectedToDate) {
      const hourDifference = dayjs(selectedToDate).diff(
        dayjs(selectedFromDate),
        "hour"
      );
      const weekDifference = dayjs(selectedToDate).diff(
        dayjs(selectedFromDate),
        "week"
      );
      const dayDifference = dayjs(selectedToDate).diff(
        dayjs(selectedFromDate),
        "day"
      );

      // Validate based on the selected schedule
      switch (selectScheduled.value) {
        case "hourly":
        case "custom": // Custom also requires a minimum 1-hour difference
          if (hourDifference < 1)
            currentError = "Time difference must be at least 1 hour";
          difference = hourDifference;
          break;
        case "daily":
          if (dayDifference < 1)
            currentError = "Date difference must be at least 1 day";
          difference = dayDifference;
          break;
        case "weekly":
          if (weekDifference < 1)
            currentError = "Date difference must be at least 1 week";
          difference = weekDifference;
          break;
        default:
          break;
      }

      // Only set difference if there is no error
      setDifference(difference);
    }

    // Set error state if any validation failed
    setError(currentError);
  }, [selectedFromDate, selectedToDate, selectScheduled]);


  const handleNext = () => {
    if (step === 0) {
      setLoader(true);
      const timeZone = dayjs.tz.guess();
      console.log("date", dayjs(selectedFromDate).format("YYYY-MM-DD hh:mm A"), selectedToDate);
      dispatch(
        forceUpdate({
          scheduled_by: authData?.username,
          scheduled_from: `${dayjs(selectedFromDate).format("YYYY-MM-DD hh:mm A")}`,
          scheduled_to: `${dayjs(selectedToDate).format("YYYY-MM-DD hh:mm A")}`,
          frequency: selectScheduled.value,
          user_id: authData.user_id,
          day: selectScheduled.value === "weekly" ? selectDay.value : "",
          timeZone,
        })
      );
    } else {
      handleClose();
    }
  };

  return (
    <>
      <Box variant="div" className="pop">
        {step === 0 ? (
          <>
            <Header handleClose={handleClose} />
            <Box variant="div" p={3}>
              <Box variant="div" display={"flex"} justifyContent={"flex-end"} mb={2}>
                {error && (
                  // <SimpleSnackbar
                  //   message={error}
                  //   open={error}
                  //   variant={"error"}
                  //   handleClose={() => setError("")}
                  // />
                  <Alert severity="error">{error}</Alert>
                )}
              </Box>
              {!loader ? (
                <ScheduleSelector
                  selectScheduled={selectScheduled}
                  handleChange={handleChange}
                  selectedFromDate={selectedFromDate}
                  setSelectedFromDate={setSelectedFromDate}
                  selectedToDate={selectedToDate}
                  setSelectedToDate={setSelectedToDate}
                  selectFromTime={selectFromTime}
                  setSelectedFromTime={setSelectedFromTime}
                  selectToTime={selectToTime}
                  setSelectedToTime={setSelectedToTime}
                  handleDayChange={handleDayChange}
                  selectDay={selectDay}
                />
              ) : (
                <Box
                  display={"flex"}
                  component={"div"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <CircularProgress />
                </Box>
              )}
            </Box>
          </>
        ) : step === 2 ? (
          <ErrorMessage />
        ) : (
          <SuccessMessage authEmail={authData?.email} />
        )}
      </Box>
      <ActionButton
        step={step}
        loader={loader}
        onClick={handleNext}
        selectedFromDate={selectedFromDate}
        selectedToDate={selectedToDate}
        difference={difference}
      />
    </>
  );
};

const Header = ({ handleClose }) => (
  <>
    <Box
      p={3}
      component={"div"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <div className="avatar-head">
        <img src={calendarIco} alt="calendar_ico" />
      </div>
      <Typography
        variant="h4"
        fontSize={24}
        fontWeight={700}
        textAlign={"center"}
        color={"#358AD4"}
      >
        Create schedule <br />
        <span style={{ fontWeight: 400, fontSize: "14px", color: "#000" }}>
          Fill in the data below to add a schedule
        </span>
      </Typography>
      <IconButton aria-label="delete" onClick={handleClose}>
        <img src={close} width={25} alt="Close" />
      </IconButton>
    </Box>
    <div style={{ borderBottom: "1px solid #DFEAF2" }}></div>
  </>
);

const ScheduleSelector = ({
  selectScheduled,
  handleChange,
  selectedFromDate,
  setSelectedFromDate,
  selectedToDate,
  setSelectedToDate,
  selectFromTime,
  setSelectedFromTime,
  selectToTime,
  setSelectedToTime,
  handleDayChange,
  selectDay,
}) => (
  <Stack spacing={3} direction="column" alignItems={"center"}>
    <Typography variant="p" fontSize={20} fontWeight={700}>
      Select your schedule
    </Typography>
    <FormControl sx={{ width: "70%", background: "none" }}>
      <Dropdown
        options={[
          { label: "Custom", value: "custom" },
          { label: "Update Hourly", value: "hourly" },
          { label: "Update Daily", value: "daily" },
          { label: "Update Weekly", value: "weekly" },
        ]}
        onSelect={(e) => {
          handleChange(e);
        }}
        selected={selectScheduled}
      />
    </FormControl>
    {selectScheduled.value === "weekly" && (
      <>
        <Typography
          variant="p"
          textAlign={"center"}
          fontSize={16}
          width={"100%"}
          fontWeight={400}
          marginY={0}
        >
          Select your day
        </Typography>
        <FormControl sx={{ width: "70%", background: "none" }}>
          <Dropdown
            options={[
              { label: "Monday", value: "monday" },
              { label: "Tuesday", value: "tuesday" },
              { label: "Wednesday", value: "wednesday" },
              { label: "Thursday", value: "thursday" },
              { label: "Friday", value: "friday" },
              { label: "Saturday", value: "saturday" },
              { label: "Sunday", value: "sunday" },
            ]}
            onSelect={(e) => handleDayChange(e)}
            selected={selectDay}
          />
        </FormControl>
      </>
    )}
    <DateTimeSection
      title="Select your Date & Time"
      selectedDate={selectedFromDate}
      setSelectedDate={setSelectedFromDate}
      selectedTime={selectFromTime}
      setSelectedTime={setSelectedFromTime}
      isTomorrow={dayjs(selectedFromDate).isAfter(Date.now())}
      selectScheduled={""}
      selectDay={selectDay}
    />
    <DateTimeSection
      title="To"
      selectedDate={selectedToDate}
      setSelectedDate={setSelectedToDate}
      selectedTime={selectToTime}
      prevSelected={selectFromTime}
      setSelectedTime={setSelectedToTime}
      isTomorrow={dayjs(selectedToDate).isAfter(Date.now())}
      selectScheduled={selectScheduled}
      selectDay={selectDay}
    />
  </Stack>
);

// Function to round the date to the nearest 5-minute interval
const roundToNearest5Minutes = (date) => {
  const minutes = dayjs(date).minute();
  const roundedMinutes = Math.round(minutes / 5) * 5;
  return dayjs(date).minute(roundedMinutes).second(0);
};

const DateTimeSection = ({
  title,
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  isTomorrow,
  prevSelected,
  selectScheduled,
  selectDay,
}) => (
  <Grid
    container
    width={"70%"}
    display={"flex"}
    alignItems={"center"}
    justifyContent={"space-between"}
  >
    <Grid item md={12} textAlign={"center"}>
      <Typography
        variant="p"
        textAlign={"center"}
        fontSize={16}
        width={"100%"}
        fontWeight={400}
      >
        {title}
      </Typography>
    </Grid>
    <Grid item md={12} marginTop={"20px"}>
      <BasicDateTimePicker
        onChange={setSelectedDate}
        value={selectedDate ? roundToNearest5Minutes(selectedDate) : null}
        selectDay={selectDay}
      />
    </Grid>
    {/* <Grid item marginTop={"20px"}>
      <TimeDropdown
        isTomorrow={isTomorrow}
        handleChange={setSelectedTime}
        prevSelected={prevSelected}
        addOneHour={selectScheduled.value === "hourly"}
      />
    </Grid> */}
  </Grid>
);

const SuccessMessage = ({ authEmail }) => (
  <Box
    variant="div"
    display={"flex"}
    flexDirection={"column"}
    p={0}
    justifyContent={"center"}
  >
    <Typography
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      variant="h5"
      fontSize={24}
      marginBottom={"20px"}
      marginTop={"20px"}
      fontWeight={500}
    >
      <img src={check} style={{ marginRight: "5px" }} alt="check" />
      Successfully Sent
    </Typography>
    <Typography
      variant="body"
      fontSize={16}
      fontWeight={400}
      marginBottom={"2px"}
      lineHeight={"28px"}
      paddingX={"17%"}
      textAlign={"center"}
    >
      Your scheduled update has been set successfully and the schedule details
      have been sent to <br />
      <span style={{ color: "#4964FF" }}>{authEmail}</span>
    </Typography>
  </Box>
);
const ErrorMessage = () => (
  <Box
    variant="div"
    display={"flex"}
    flexDirection={"column"}
    p={3}
    justifyContent={"center"}
  >
    <Typography
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      variant="h5"
      fontSize={24}
      marginBottom={"20px"}
      marginTop={"20px"}
      fontWeight={500}
    >
      {/* <img src={check} style={{ marginRight: "5px" }} alt="check" /> */}
      <HighlightOffIcon sx={{ color: "#CF1E21", fontSize: "40px" }} />
      Error Occurred
    </Typography>
    <Typography
      variant="body"
      fontSize={16}
      fontWeight={400}
      marginBottom={"2px"}
      lineHeight={"28px"}
      paddingX={"17%"}
      textAlign={"center"}
    >
      An error occurred while setting your scheduled update
    </Typography>
  </Box>
);

const ActionButton = ({
  step,
  loader,
  onClick,
  selectedFromDate,
  selectedToDate,
  difference,
}) => (
  <Box
    className="btn_periodic"
    variant="div"
    display={"flex"}
    marginTop={"20px"}
    marginBottom={"20px"}
    width={"65%"}
    marginX={"auto"}
    justifyContent={"center"}
  >
    <Button
      variant="contained"
      size="large"
      className="nxt_btn"
      sx={{
        fontSize: "16px !important",
        background: "#358AD4",
      }}
      onClick={onClick}
      disabled={
        loader || !selectedFromDate || !selectedToDate || difference < 1
      }
    >
      {step === 0 ? "Next" : "Done"}
      {step === 0 && (
        <img src={rightArrow} style={{ marginLeft: "10px" }} alt="Next" />
      )}
    </Button>
  </Box>
);

export default Periodic;
